<template>
  <div class="container-fluid">
    <div class="row listBar">
      <div class="col">
        <div class="Groupbuies">進行中的團購</div><div class="Arrangement">團購截止時間</div>
      </div>
    </div>
    <div class="row Groupbuies" v-for="(Groupbuy, index) in Groupbuies" :key="(Groupbuy, index)" @click="copy(Groupbuy)">
      <hr>
      <div class="col shopURL">
        <div class="shopName">{{Groupbuy.shopName}}</div>
        <a :href="'http://line.naver.jp/R/msg/text/?聽說這家店很讚！等你來一起團購唷[' + Groupbuy.shopName + ']%0D%0A' + Global.Domain + '/OrderUser/Shop/' + Groupbuy.shopId + '/' + Groupbuy.Token">
          <img class="shareIcon" src="./../../assets/img/LINE.png" />
        </a>
        <input type="text" :id="Groupbuy.Token" :value="Global.Domain + '/OrderUser/Shop/' + Groupbuy.shopId + '/' + Groupbuy.Token">
      </div>
      <div class="col endTime">
        <div class="tokenTime">{{$moment.unix(Groupbuy.Token).format("YYYY-MM-DD HH:mm")}}</div>
        <input v-if="Global.Groupbuy[Groupbuy.Token]" type="button" class="btn btn-sm btn-primary" :value="'前往結帳（' + Global.Groupbuy[Groupbuy.Token]?.length + '）'" @click="goGroupbuy(Groupbuy)">
        <input v-else type="button" class="btn btn-sm btn-primary" value="前往結帳（0）" @click="goGroupbuy(Groupbuy)">
      </div>
    </div>
    <div class="row FooterSpace"></div>
    <div class="row Footer">
      <div class="col">
        <button class="btn" @click="Home()">
          <i class="fas fa-home"></i><br><span>首頁</span>
        </button>
      </div>
      <div class="col">
        <button class="btn" @click="User()">
          <i class="fa-solid fa-user"></i><br><span>會員</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { Global } from '@/Service/GlobalService'

import { getUserGroupbuies } from '@/Service/APIService'

export default {
  name: "Attentions",
  data() {
    return {
      Global: Global,                           // 給上方 HTML 使用
      Groupbuies: null,                         // 消費者團購列表
      GroupbuyLength: Global.Groupbuy?.length,  // 團購購物車
      URL: null                                 // 團購網址
    }
  },
  methods: {
    /* 初始化，取得消費者團購列表 */
    init: async function() {
      const response = await getUserGroupbuies()

      this.$data.Groupbuies = response.data
      setInterval(() => { 
        this.$data.GroupbuyLength = Global.Groupbuy?.length
        this.$forceUpdate() 
      }, 1000)
    },
    /* 複製網址 */
    copy: function(Groupbuy) {
      document.getElementById(Groupbuy.Token).select()
      document.execCommand('copy')
      document.getElementById(Groupbuy.Token).disabled = true
    },
    /* 前往首頁頁面 */
    Home: function() {
      this.$router.push({ name: `Home` })
    },
    /* 前往會員資料頁面 */
    User: function() {
      this.$router.push({ name: `User` })
    },
    /* 前往店家頁面（團購Token） */
    goGroupbuy: function(Groupbuy) {
      if (Global.Groupbuy[Groupbuy.Token].length == 0) {
        this.$swal.fire({
          icon: 'error',
          title: '無法前往結帳',
          text: '無人跟揪，無法前往結帳'
        })
        return false
      }
      this.$router.push({ path: `/Shop/${Groupbuy.shopId}/${Groupbuy.Token}` })
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.container-fluid, .row {
  margin: 0px;
  padding: 0px;
  > .listBar {
    margin: 0px;
    padding: 10px 0px;
    background-color: #87CEFAAA;
    color: #000000;
    text-shadow: 1px 1px 0 #FFFFFF;
    font-size: 18px;
    font-weight: 900;
    > .col {
      > .Groupbuies {
        float: left;
        padding-left: 15px;
      }
      > .Arrangement {
        float: right;
        padding-right: 15px;
        > .Arrow {
          margin-left: 10px;
        }
      }
    }
  }
  > .Groupbuies {
    margin-bottom: 10px;
    font-weight: bold;
    > .shopURL {
      padding-left: 25px;
      .shareIcon {
        display: inline;
        margin-right: 10px;
        height: 40px;
      }
      > input[type=text] {
        padding-top: 10px;
        width: calc(100% - 55px);
        border: none;
        text-overflow: ellipsis;
        display: inline;
        white-space: nowrap;
      }
    }
    > .endTime {
      text-align: right;
      padding-right: 15px;
    }
  }
> .FooterSpace {
    height: 70px;
  }
  > .Footer {
    position: fixed;
    bottom: 0;
    text-align: center;
    width: 100%;
    height: 70px;
    background-color: #5599FF;
    > .col {
      > .btn {
        border: 0px;
        background-color: #5599FF;
        box-shadow: 0px 0px 0px 0px;
        color: #FFFFFF;
        font-size: 20px;
        font-weight: 900;
        > .fas {
          margin-bottom: 3px;
          font-size: 24px;
        }
      }
    }
  }
}
</style>